import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {AvaliacaoService} from "../../services/avaliacao.service";
import {DominiosService} from "../../services/dominios.service";

// "★ 4,9 · 87 avaliações" no topo da loja; só aparece com avaliação publicada pelo dono.
@Component({
  selector: 'app-selo-avaliacoes',
  template: `
    <a class="selo-avaliacoes" *ngIf="resumo?.total" href="#" (click)="abra($event)"
       [attr.aria-label]="'Nota ' + (resumo.media | number: '1.1-1') + ' em ' + resumo.total + ' avaliações. Ver avaliações'">
      <span class="selo-estrela" aria-hidden="true">&#9733;</span>
      <strong>{{resumo.media | number: '1.1-1'}}</strong>
      <span class="selo-ponto" aria-hidden="true">·</span>
      <span>{{resumo.total}} {{resumo.total === 1 ? 'avaliação' : 'avaliações'}}</span>
      <i class="fas fa-chevron-right" aria-hidden="true"></i>
    </a>
  `,
  styles: [`
    .selo-avaliacoes {
      display: inline-flex;
      align-items: center;
      gap: 5px;
      max-width: 100%;
      margin: 4px 0;
      padding: 3px 10px 3px 8px;
      border: 1px solid rgba(245, 177, 6, .35);
      border-radius: 999px;
      background: #fffaeb;
      color: #1f2937;
      font-size: 13px;
      line-height: 20px;
      white-space: nowrap;
      text-decoration: none;
      font-variant-numeric: tabular-nums;
      transition: background-color .15s, border-color .15s;
    }

    .selo-avaliacoes:hover {
      background: #fff3cc;
      border-color: rgba(245, 177, 6, .6);
      color: #1f2937;
      text-decoration: none;
    }

    .selo-estrela {
      color: #f5b106;
      font-size: 14px;
    }

    strong {
      font-weight: 700;
    }

    .selo-ponto {
      color: #9ca3af;
    }

    i {
      margin-left: 2px;
      font-size: 10px;
      color: #9ca3af;
    }
  `]
})
export class SeloAvaliacoesComponent implements OnInit {
  resumo: any = null;

  constructor(private avaliacaoService: AvaliacaoService, private dominiosService: DominiosService,
              private router: Router) { }

  ngOnInit(): void {
    this.avaliacaoService.obtenhaResumoPublico().then((resumo: any) => {
      this.resumo = resumo;
    });
  }

  // O topo do desktop leva para a home ao clicar em qualquer ponto do nome da loja.
  abra(evento: any) {
    evento.preventDefault();
    evento.stopPropagation();

    this.router.navigateByUrl(this.dominiosService.obtenhaUrlCompleta('avaliacoes'));
  }
}
